import React, { Component } from 'react';
import { connect } from 'react-redux';
// utils
import { Translations } from '../../../utils';
// constant
import { FORM_REFS } from '../../../constants';
// restClient
import { aemHostClient, eapiClient } from '../../../restClient';
// children
import Dynamicform from '../../common/Dynamicform/dynamicForm';
import { blockUi, unBlockUi } from '../../../actions/actionCreator';

export class CreateCorporateCard extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {
    let apiURL = "/aemData/formData/json_add-corporate-card-page";

    aemHostClient(apiURL)
      .then(({ data }) => {
        document.title = `${Translations(data.par.aemform_addCorporateCardPage.title, this.props.lang.currentLang.lang, this.props.lang.translatedData)} - ${'HSBC GLCM'}`
        this.setState({ formJson: data });
      });
  }

  getFormData = (formData) => {
    this.setState({ formData });
  }

  onFormSubmit = (event, apiUrl) => {
    this.props.blockUi();
    const caseId = this.state.formData.entity ? (this.state.formData.entity.value) : undefined;
    const productType = 'corporate-card';
    var requestData = { ...this.state.formData };
    requestData.caseId = caseId;
    requestData.productType = productType;
    // requestData.isoCode = isoCode;
    eapiClient(apiUrl, {
      method: 'POST',
      data: JSON.stringify(requestData)
    })
      .then(({ data }) => {
        this.props.history.goBack();
        this.props.unBlockUi();
      });
  }

  onFormCancel = () => {
    this.props.history.goBack();
  }

  renderFormGroups() {
    let formData = {};
    const properties = {
      caseId: this.props.match.params.caseId,
      formData,
      editType: 'add-corporate-card-to-case',
      pathname: this.props.history.location.pathname
    };
    if (this.state.formJson !== undefined && this.state.formJson.par.aemform_addCorporateCardPage !== undefined) {
      return (
        <Dynamicform mode={this.props.mode}
          properties={properties}
          url={FORM_REFS[this.state.formJson.par.aemform_addCorporateCardPage.formRef]}
          getFormData={this.getFormData}
          onFormSubmit={this.onFormSubmit}
          onFormCancel={this.onFormCancel}
          lang={this.props.lang.currentLang.lang}
          translatedData={this.props.lang.translatedData}
          flag={this.props.lang.currentLangFlag.flag}
          productList={this.props.corporateCardProductList}
          isAssociation={false}
        />
      );
    }
  }

  render() {
    const pageTitle = this.state.formJson ? this.state.formJson.par.aemform_addCorporateCardPage : '';
    return (
      <div className="form-container">
        <div className="form-title">
          <h2 className="form-heading">
            {Translations(pageTitle.title, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
          </h2>
          <p className="form-required-desc">
            {Translations(pageTitle.description, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
          </p>
        </div>
        {this.renderFormGroups()}
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    lang: state.lang,
    corporateCardProductList: state.productDetails.corporateCard
  }
}

const mapDispatchToProps = dispatch => {
  return {
    blockUi: () => {
      dispatch(blockUi())
    },
    unBlockUi: () => {
      dispatch(unBlockUi())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateCorporateCard)



// WEBPACK FOOTER //
// ./src/components/CaseBody/ProductRequests/CreateCorporateCard.js